import i18n from '@/lang/i18n'
import { DashboardModuleArea, dashboardModuleGridMaxCols, DashboardModuleLayoutWidget, DashboardModuleLayoutWidgetRenderComponent, DashboardModuleLayoutWidgetSubType, DashboardModuleLayoutWidgetWidgetLink, DashboardModuleSection, DashboardModuleWidgetOption } from '@/modules/dashboard-module/shared/models/dashboard-module.model'

export const dashboardModuleLayoutWidgets = (): DashboardModuleLayoutWidget[] => ([] as DashboardModuleLayoutWidget[]).concat(
    dashboardModuleLayoutWidgetsPendingElements(),
    dashboardModuleLayoutWidgetsChart(),
    dashboardModuleLayoutWidgetsUtilities(),
    dashboardModuleLayoutWidgetsInterestData()
)

const dashboardModuleLayoutWidgetsPendingElements = (): DashboardModuleLayoutWidget[] => {
    const initPendingWidgets = [
        {
            id: '0',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.CLINICAL,
            icon: 'fal fa-envelope-open-text',
            label: i18n.tc('dashboard.widget.unreadRequests'),
            moduleLabel: i18n.tc('dashboard.widget.category.requests'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.CLINICAL_GRID,
            widgetOption: DashboardModuleWidgetOption.REQUESTS_WITH_AP_REPORT_NOT_SEEN
        },
        {
            id: '1',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.CLINICAL,
            icon: 'fal fa-file-times',
            label: i18n.tc('dashboard.widget.blockedRequests'),
            moduleLabel: i18n.tc('dashboard.widget.category.requests'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.CLINICAL_GRID,
            widgetOption: DashboardModuleWidgetOption.LOCKED_REQUESTS
        },
        {
            id: '2',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.REQUEST,
            icon: 'fal fa-hourglass-start',
            label: i18n.tc('dashboard.widget.pendingRequests'),
            moduleLabel: i18n.tc('dashboard.widget.category.requestBox'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.REQUEST_GRID,
            widgetOption: DashboardModuleWidgetOption.REGISTRY_REQUESTED
        },
        {
            id: '3',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.REQUEST,
            icon: 'fal fa-file-times',
            label: i18n.tc('dashboard.widget.blockedRequests'),
            moduleLabel: i18n.tc('dashboard.widget.category.requestBox'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.REQUEST_GRID,
            widgetOption: DashboardModuleWidgetOption.REGISTRY_REQUESTS_LOCKED
        },
        {
            id: '4',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.REGISTRY,
            icon: 'fal fa-calendar-day',
            label: i18n.tc('dashboard.widget.registeredToday'),
            moduleLabel: i18n.tc('dashboard.widget.category.registry'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.CASE_GRID,
            widgetOption: DashboardModuleWidgetOption.REGISTRY_TODAY
        },
        {
            id: '5',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.GROSSING,
            icon: 'icon-scalpel-menu',
            label: i18n.tc('dashboard.widget.pendingGrossing'),
            moduleLabel: i18n.tc('dashboard.widget.category.grossing'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.GROSSING_GRID,
            widgetOption: DashboardModuleWidgetOption.FOR_GROSSING
        },
        {
            id: '6',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.GROSSING,
            icon: 'icon-scalpel-reload',
            label: i18n.tc('dashboard.widget.pendingRegrossing'),
            moduleLabel: i18n.tc('dashboard.widget.category.grossing'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.GROSSING_GRID,
            widgetOption: DashboardModuleWidgetOption.FOR_REGROSSING
        },
        {
            id: '7',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.GROSSING,
            icon: 'fal fa-calendar-day',
            label: i18n.tc('dashboard.widget.grossingToday'),
            moduleLabel: i18n.tc('dashboard.widget.category.grossing'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.GROSSING_GRID,
            widgetOption: DashboardModuleWidgetOption.GROSSING_TODAY
        },
        {
            id: '8',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.WASTE,
            icon: 'fal fa-trash',
            label: i18n.tc('dashboard.widget.pendingWaste'),
            moduleLabel: i18n.tc('dashboard.widget.category.waste'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.WASTE_GRID,
            widgetOption: DashboardModuleWidgetOption.PENDING_DISPOSAL
        },
        {
            id: '9',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.WASTE,
            icon: 'fal fa-calendar-day',
            label: i18n.tc('dashboard.widget.wasteToday'),
            moduleLabel: i18n.tc('dashboard.widget.category.waste'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.WASTE_GRID,
            widgetOption: DashboardModuleWidgetOption.WASTE_TODAY
        },
        {
            id: '10',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.INCIDENTS,
            icon: 'fal fa-exclamation-triangle',
            label: i18n.tc('dashboard.widget.openIncidents'),
            moduleLabel: i18n.tc('dashboard.widget.category.incidents'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.INCIDENTS_MODULE,
            widgetOption: DashboardModuleWidgetOption.OPENED_INCIDENTS
        },
        {
            id: '17',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.LABORATORY,
            icon: 'icon-block',
            label: i18n.tc('dashboard.widget.pendingConfection'),
            moduleLabel: i18n.tc('dashboard.widget.category.laboratory'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.LABORATORY_MODULE,
            widgetOption: DashboardModuleWidgetOption.PORTION_MAKE
        },
        {
            id: '18',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.LABORATORY,
            icon: 'fal fa-scalpel-path',
            label: i18n.tc('dashboard.widget.pendingCut'),
            moduleLabel: i18n.tc('dashboard.widget.category.laboratory'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.LABORATORY_MODULE,
            widgetOption: DashboardModuleWidgetOption.PORTION_CUT
        },
        {
            id: '19',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.LABORATORY,
            icon: 'fal fa-barcode-alt',
            label: i18n.tc('dashboard.widget.pendingScan'),
            moduleLabel: i18n.tc('dashboard.widget.category.laboratory'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.LABORATORY_MODULE,
            widgetOption: DashboardModuleWidgetOption.SUBPORTION_TO_SCANNER
        },
        {
            id: '20',
            area: DashboardModuleArea.PENDING_ELEMENTS,
            section: DashboardModuleSection.LABORATORY,
            icon: 'fal fa-barcode-alt',
            label: i18n.tc('dashboard.widget.pendingScanDeparture'),
            moduleLabel: i18n.tc('dashboard.widget.category.laboratory'),
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.LABORATORY_MODULE,
            widgetOption: DashboardModuleWidgetOption.SUBPORTION_SCAN
        }
    ]
    return initPendingWidgets.map((item) => {
        const widget: DashboardModuleLayoutWidget = {
            ...item,
            hidden: true,
            disabled: false,
            renderComponent: DashboardModuleLayoutWidgetRenderComponent.PENDING_WIDGET,
            color: 'gradiant-blue',
            coordinates: null,
            width: 1,
            height: 2
        }
        return widget
    })
}

const dashboardModuleLayoutWidgetsChart = (): DashboardModuleLayoutWidget[] => {
    return []
}

const dashboardModuleLayoutWidgetsUtilities = (): DashboardModuleLayoutWidget[] => {
    const initialUtilitiesWidgets = [
        {
            id: '11',
            area: DashboardModuleArea.UTILITIES,
            section: DashboardModuleSection.REGISTRY,
            renderComponent: DashboardModuleLayoutWidgetRenderComponent.NEW_CASE_WIDGET,
            icon: 'fal fa-chart-network',
            label: i18n.tc('dashboard.widget.newCase'),
            moduleLabel: i18n.tc('dashboard.widget.category.registry'),
            subType: DashboardModuleLayoutWidgetSubType.CASE,
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.NEW_CASE,
            width: dashboardModuleGridMaxCols,
            height: 2
        },
        {
            id: '12',
            area: DashboardModuleArea.UTILITIES,
            section: DashboardModuleSection.CLINICAL,
            renderComponent: DashboardModuleLayoutWidgetRenderComponent.NEW_CASE_WIDGET,
            icon: 'fal fa-file-medical',
            label: i18n.tc('dashboard.widget.newRequest'),
            moduleLabel: i18n.tc('dashboard.widget.category.requests'),
            subType: DashboardModuleLayoutWidgetSubType.REQUEST,
            widgetLink: DashboardModuleLayoutWidgetWidgetLink.NEW_CASE,
            width: dashboardModuleGridMaxCols,
            height: 2
        }
        // {
        //     id: '20',
        //     area: DashboardModuleArea.UTILITIES,
        //     section: DashboardModuleSection.REGISTRY,
        //     renderComponent: DashboardModuleLayoutWidgetRenderComponent.PRINT_LABELS,
        //     icon: 'fal fa-ticket-alt',
        //     label: i18n.tc('component.printLabelsModal.printLabels'),
        //     moduleLabel: i18n.tc('dashboard.widget.category.registry'),
        //     width: 12,
        //     height: 6
        // }
    ]
    return initialUtilitiesWidgets.map((item) => {
        const widget: DashboardModuleLayoutWidget = {
            ...item,
            hidden: true,
            disabled: false,
            coordinates: null
        }
        return widget
    })
}

const dashboardModuleLayoutWidgetsInterestData = (): DashboardModuleLayoutWidget[] => []
